//import "./App.css";
import { Link } from "react-router-dom";

export const Impressum = (props) => {
  return (
    <div>
        <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <a className='navbar-brand page-scroll' href='#page-top'>
            Doing <span style={{color: "orange"}}> Good</span>  <br />Together <br /><span style={{color: "orange"}}>Düsseldorf</span>
          </a>{' '}
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <Link to="/">Home</Link><br />
            </li>
          </ul>
         
        </div>
      </div>
       <br />

    </nav>


{/*   */}
  <header id='header'>
      <div className=''>
        <div className='overlay'>
          <div className='container'>
            <div className='row'>
               <div className='col-md-8 col-md-offset-2 intro-text'> 
               <h1>Inhaltsverzeichnis</h1>
<ul>
    <li><a href="#kontakt">Kontakt</a></li>
    <li><a href="#verantwortlich-für-den-inhalt-nach--55-abs-2-rstv">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</a></li>
    <li><a href="#haftungsausschluss">Haftungsausschluss</a>
      <ul>
        <li><a href="#1-haftung-für-inhalte">1. Haftung für Inhalte</a></li>
        <li><a href="#2-verweise-auf-andere-webseiten">2. Verweise auf andere Webseiten</a></li>
        <li><a href="#3-urheber--und-kennzeichenrecht">3. Urheber- und Kennzeichenrecht</a></li>
        <li><a href="#4-rechtswirksamkeit-dieses-haftungsausschlusses">4. Rechtswirksamkeit dieses Haftungsausschlusses</a></li>
        <li><a href="#5-datenschutz">5. Datenschutz</a></li>
      </ul>
    </li>
  </ul>
  <h2 id="kontakt">Kontakt</h2>
<strong>Doing Good Together Düsseldorf</strong><br />
<p>E-Mail: <a href="mailto:info@doinggoodtogether.de"><a href="mailto:info@doinggoodtogether.de">info@doinggoodtogether.de</a></a></p>
<p></p>
<h2 id="verantwortlich-für-den-inhalt-nach--55-abs-2-rstv">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
<p>Malte Klane</p>
c/o Grosch Postflex #1930<br />
Emsdettener Str. 10<br />
48268 Greven<br />
<h2 id="haftungsausschluss">Haftungsausschluss</h2>
<h3 id="1-haftung-für-inhalte">1. Haftung für Inhalte</h3>
<p>Die Inhalte unseres Onlineangebots wurden nach bestem Wissen und Gewissen zusammengestellt. Wir übernehmen jedoch keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der bereitgestellten Informationen. Haftungsansprüche gegen uns, welche sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden, sind grundsätzlich ausgeschlossen.</p>
<p>Ebenfalls ausgeschlossen sind Haftungsansprüche für jegliche unmittelbaren und mittelbaren Schäden, die durch den Zugriff auf unser Onlineangebot entstehen, z. B. durch die Infizierung mit Computerviren. Alle dargebotenen Inhalte sind freibleibend und unverbindlich.</p>
<p>Wir behalten uns ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.</p>
<h3 id="2-verweise-auf-andere-webseiten">2. Verweise auf andere Webseiten</h3>
<p>Auf unserer Webseite wird auf die Webseiten Dritter verwiesen. Wir übernehmen keine Verantwortung für die Inhalte der verlinkten Seiten. Mit dem Betätigen des Verweises verlassen Sie unser Informationsangebot. Für die Angebote Dritter können daher abweichende Regelungen gelten, insbesondere auch hinsichtlich des Datenschutzes.</p>
<p>Wir erklären hiermit ausdrücklich, dass zum Zeitpunkt der Linksetzung keine illegalen Inhalte auf den Seiten erkennbar waren, auf die direkt verwiesen wurde. Auf die aktuelle und zukünftige Gestaltung, die Inhalte oder die Urheberschaft der gelinkten/verknüpften Informationsseiten haben wir keinerlei Einfluss. Deshalb distanzieren wir uns hiermit ausdrücklich von allen Inhalten aller gelinkten/verknüpften Seiten, die nach der Linksetzung verändert wurden.</p>
<p>Diese Feststellung gilt für alle innerhalb unseres Internetangebotes gesetzten Links und Verweise. Für illegale, fehlerhafte oder unvollständige Inhalte und insbesondere für Schäden, die aus der Nutzung oder Nichtnutzung solcherart dargebotener Informationen entstehen, haftet allein der Verantwortliche der Seite, auf welche verwiesen wurde.</p>
<h3 id="3-urheber--und-kennzeichenrecht">3. Urheber- und Kennzeichenrecht</h3>
<p>Unser Onlineangebot ist urheberrechtlich (copyright) geschützt. Alle Rechte für den Inhalt und die Gestaltung stehen alleine uns zu. Das vollständige oder teilweise Reproduzieren, Verbreiten, Übermitteln (elektronisch oder auf andere Weise), Modifizieren oder Benutzen unserer Webseite für öffentliche oder kommerzielle Zwecke ist ohne die vorherige schriftliche Zustimmung von uns untersagt.</p>
<p>Wir sind bestrebt, in allen Publikationen die Urheberrechte der verwendeten Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von uns selbst erstellte Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte zurückzugreifen.</p>
<p>Alle innerhalb unseres Internetangebotes genannten und ggf. durch Dritte geschützten Marken und Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen Eigentümer. Allein aufgrund der bloßen Nennung ist nicht der Schluss zu ziehen, dass Markenzeichen nicht durch Rechte Dritter geschützt sind.</p>
<h3 id="4-rechtswirksamkeit-dieses-haftungsausschlusses">4. Rechtswirksamkeit dieses Haftungsausschlusses</h3>
<p>Dieser Haftungsausschluss ist als Teil unseres Internetangebotes zu betrachten, von dem aus auf diese Seite verwiesen wurde. Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen sollten, bleiben die übrigen Teile des Dokumentes in ihrem Inhalt und ihrer Gültigkeit davon unberührt.</p>
<h3 id="5-datenschutz">5. Datenschutz</h3>
<p>Die Nutzung unserer oben angegebenen Kontaktdaten zum Zwecke der gewerblichen Werbung ist ohne schriftliche Zustimmung von uns oder ohne einer bestehenden Geschäftsbeziehung ausdrücklich nicht erwünscht. Wir und alle auf unserer Webseite genannten Personen widersprechen ausdrücklich jeder kommerziellen Verwendung und Weitergabe unserer bzw. ihrer Daten.</p>
<p>Ausführliche Informationen zum Datenschutz sind in der folgenden Datenschutzerklärung zu finden.</p>

                    
                    <p className="text-sm mt-10">
                    2021-11-22
                    </p>



              </div>  
            </div>
          </div>
        </div>
      </div>
    </header>



    <div id="introduction" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>Datenschutzerklärung</h2>
          <div>
           <h1 className="adsimple-311886100">Einleitung und Überblick</h1>

<p>
  Wir haben diese Datenschutzerklärung (Fassung 23.11.2021-311886100) verfasst,
  um Ihnen gemäß der Vorgaben der
  <a
    className="adsimple-311886100"
    href="https://eur-lex.europa.eu/legal-content/DE/ALL/?uri=celex%3A32016R0679&amp;tid=311886100"
    target="_blank"
    rel="noopener noreferrer"
    > Datenschutz-Grundverordnung (EU) 2016/679 </a>
  und anwendbaren nationalen Gesetzen zu erklären, welche personenbezogenen
  Daten (kurz Daten) wir als Verantwortliche &#8211; und die von uns
  beauftragten Auftragsverarbeiter (z. B. Provider) &#8211; verarbeiten,
  zukünftig verarbeiten werden und welche rechtmäßigen Möglichkeiten Sie haben.
  Die verwendeten Begriffe sind geschlechtsneutral zu verstehen.<br />
  <strong className="adsimple-311886100">Kurz gesagt:</strong> Wir informieren Sie
  umfassend über Daten, die wir über Sie verarbeiten.
</p>
<p>
  Wenn trotzdem Fragen bleiben, möchten wir Sie bitten, sich an die unten bzw.
  im Impressum genannte verantwortliche Stelle zu wenden, den vorhandenen Links
  zu folgen und sich weitere Informationen auf Drittseiten anzusehen. Unsere
  Kontaktdaten finden Sie selbstverständlich auch im Impressum.
</p>
<h2 id="anwendungsbereich" className="adsimple-311886100">Anwendungsbereich</h2>
<p>
  Diese Datenschutzerklärung gilt für alle von uns verarbeiteten
  personenbezogenen Daten und für alle personenbezogenen Daten, die von uns
  beauftragte Firmen (Auftragsverarbeiter) verarbeiten. Mit personenbezogenen
  Daten meinen wir Informationen im Sinne des Art. 4 Nr. 1 DSGVO wie zum
  Beispiel Name, E-Mail-Adresse und postalische Anschrift einer Person. Die
  Verarbeitung personenbezogener Daten sorgt dafür, dass wir dich über unsere
  Aktivitäten informieren können, sei es online
  oder offline. Der Anwendungsbereich dieser Datenschutzerklärung umfasst alle Onlineauftritte, die wir betreiben.
</p>
<p>
  <strong className="adsimple-311886100">Kurz gesagt:</strong> Die
  Datenschutzerklärung gilt für alle Bereiche, in denen personenbezogene Daten
  über die genannten Kanäle strukturiert verarbeitet werden.
  Sollten wir außerhalb dieser Kanäle mit Ihnen in Rechtsbeziehungen eintreten,
  werden wir Sie gegebenenfalls gesondert informieren.
</p>
<h2 id="rechtsgrundlagen" className="adsimple-311886100">Rechtsgrundlagen</h2>
<p>
  In der folgenden Datenschutzerklärung geben wir Ihnen transparente
  Informationen zu den rechtlichen Grundsätzen und Vorschriften, also den
  Rechtsgrundlagen der Datenschutz-Grundverordnung, die uns ermöglichen,
  personenbezogene Daten zu verarbeiten.<br />
  Was das EU-Recht betrifft, beziehen wir uns auf die VERORDNUNG (EU) 2016/679
  DES EUROPÄISCHEN PARLAMENTS UND DES RATES vom 27. April 2016. Diese
  Datenschutz-Grundverordnung der EU können Sie selbstverständlich online auf
  EUR-Lex, dem Zugang zum EU-Recht, unter
  <a
    className="adsimple-311886100"
    href="https://eur-lex.europa.eu/legal-content/DE/ALL/?uri=celex%3A32016R0679&amp;tid=311886100"
    target="_blank"
    rel="noopener noreferrer"
    > https://eur-lex.europa.eu/legal-content/DE/TXT/?uri=celex%3A32016R0679 </a
  >
   nachlesen.
</p>
<p>
  Wir verarbeiten Ihre Daten nur, wenn mindestens eine der folgenden Bedingungen
  zutrifft:
</p>
<ol>
  <li className="adsimple-311886100">
    <strong className="adsimple-311886100">Einwilligung</strong> (Artikel 6 Absatz 1
    lit. a DSGVO): Sie haben uns Ihre Einwilligung gegeben, Daten zu einem
    bestimmten Zweck zu verarbeiten. Ein Beispiel wäre die Speicherung Ihrer
    eingegebenen Daten eines Kontaktformulars.
  </li>
  <li className="adsimple-311886100">
    <strong className="adsimple-311886100">Rechtliche Verpflichtung </strong>
    (Artikel 6 Absatz 1 lit. c DSGVO): Wenn wir einer rechtlichen Verpflichtung
    unterliegen, verarbeiten wir Ihre Daten. 
  </li>
  <li className="adsimple-311886100">
    <strong className="adsimple-311886100">Berechtigte Interessen</strong> (Artikel
    6 Absatz 1 lit. f DSGVO): Im Falle berechtigter Interessen, die Ihre
    Grundrechte nicht einschränken, behalten wir uns die Verarbeitung
    personenbezogener Daten vor. Wir müssen zum Beispiel gewisse Daten
    verarbeiten, um unsere Website sicher und wirtschaftlich effizient betreiben
    zu können. Diese Verarbeitung ist somit ein berechtigtes Interesse.
  </li>
</ol>
<h3 className="adsimple-311886100">
    Warum verarbeiten wir personenbezogene Daten?
</h3>
<p>Die Zwecke der Datenverarbeitung sind:</p>
<ol>
    <li className="adsimple-311886100">
        Kontaktaufnahme zwecks Information über unsere Aktivitäten
    </li>
</ol>
<h3 className="adsimple-311886100">Welche Daten werden verarbeitet?</h3>
<p>
    Wir verarbeiten lediglich im Kontaktformular eingegebene Daten (Name und Email).
</p>
<h3 className="adsimple-311886100">Wie lange werden Daten gespeichert?</h3>
<p>
    Die Daten werden so lange gespeichert wie sie zwecks Kommunikation gebraucht werden. Wir geben diese Daten nicht
    weiter, können jedoch
    nicht ausschließen, dass diese Daten beim Vorliegen von rechtswidrigem
    Verhalten von Behörden eingesehen werden.
</p>
<p>
  Weitere Bedingungen wie die Wahrnehmung von Aufnahmen im öffentlichen
  Interesse und Ausübung öffentlicher Gewalt sowie dem Schutz lebenswichtiger
  Interessen treten bei uns in der Regel nicht auf. Soweit eine solche
  Rechtsgrundlage doch einschlägig sein sollte, wird diese an der entsprechenden
  Stelle ausgewiesen.
</p>
<p>Zusätzlich zu der EU-Verordnung gelten auch noch nationale Gesetze:</p>
<ul className="adsimple-311886100">
  <li className="adsimple-311886100">
    In <strong className="adsimple-311886100">Deutschland</strong> gilt das
    <strong className="adsimple-311886100"> Bundesdatenschutzgesetz</strong>,
    kurz<strong className="adsimple-311886100"> BDSG</strong>.
  </li>
</ul>
<p>
  Sofern weitere regionale oder nationale Gesetze zur Anwendung kommen,
  informieren wir Sie in den folgenden Abschnitten darüber.
</p>
<h2 id="kontaktdaten-verantwortliche" className="adsimple-311886100">
  Kontaktdaten des Verantwortlichen
</h2>
<p>
  Sollten Sie Fragen zum Datenschutz haben, finden Sie nachfolgend die
  Kontaktdaten der verantwortlichen Person bzw. Stelle:<br />
  <span className="adsimple-311886100" style={{fontWeight: "400"}}><br />
    Malte Klane<br />
    c/o Grosch Postflex #1930<br />
    Emsdettener Str. 10<br />
    48268 Greven<br /></span>
  
  <br />
  E-Mail: <a href="mailto:info@doinggoodtogether.de">info@doinggoodtogether.de</a>
  <br />
  Impressum:
  <Link to="/Impressum"> Impressum</Link><br />
</p>
<h2 id="speicherdauer" className="adsimple-311886100">Speicherdauer</h2>
<p>
  Dass wir personenbezogene Daten nur so lange speichern, wie es für die
  Information über unsere Aktivitäten notwendig ist,
  gilt als generelles Kriterium bei uns. Das bedeutet, dass wir personenbezogene
  Daten löschen, sobald der Grund für die Datenverarbeitung nicht mehr vorhanden
  ist. In einigen Fällen sind wir gesetzlich dazu verpflichtet, bestimmte Daten
  auch nach Wegfall des ursprüngliches Zwecks zu speichern, zum Beispiel zu
  Zwecken der Buchführung.
</p>
<p>
  Sollten Sie die Löschung Ihrer Daten wünschen oder die Einwilligung zur
  Datenverarbeitung widerrufen, werden die Daten so rasch wie möglich und soweit
  keine Pflicht zur Speicherung besteht, gelöscht.
</p>
<p>
  Über die konkrete Dauer der jeweiligen Datenverarbeitung informieren wir Sie
  weiter unten, sofern wir weitere Informationen dazu haben.
</p>
<h2 id="rechte-dsgvo" className="adsimple-311886100">
  Rechte laut Datenschutz-Grundverordnung
</h2>
<p>
  Laut Artikel 13 DSGVO stehen Ihnen die folgenden Rechte zu, damit es zu einer
  fairen und transparenten Verarbeitung von Daten kommt:
</p>
<ul className="adsimple-311886100">
  <li className="adsimple-311886100">
    Sie haben laut Artikel 15 DSGVO ein Auskunftsrecht darüber, ob wir Daten von
    Ihnen verarbeiten. Sollte das zutreffen, haben Sie Recht darauf eine Kopie
    der Daten zu erhalten und die folgenden Informationen zu erfahren:
    <ul className="adsimple-311886100">
      <li className="adsimple-311886100">
        zu welchem Zweck wir die Verarbeitung durchführen;
      </li>
      <li className="adsimple-311886100">
        die Kategorien, also die Arten von Daten, die verarbeitet werden;
      </li>
      <li className="adsimple-311886100">
        wer diese Daten erhält und wenn die Daten an Drittländer übermittelt
        werden, wie die Sicherheit garantiert werden kann;
      </li>
      <li className="adsimple-311886100">
        wie lange die Daten gespeichert werden;
      </li>
      <li className="adsimple-311886100">
        das Bestehen des Rechts auf Berichtigung, Löschung oder Einschränkung
        der Verarbeitung und dem Widerspruchsrecht gegen die Verarbeitung;
      </li>
      <li className="adsimple-311886100">
        dass Sie sich bei einer Aufsichtsbehörde beschweren können (Links zu
        diesen Behörden finden Sie weiter unten);
      </li>
      <li className="adsimple-311886100">
        die Herkunft der Daten, wenn wir sie nicht bei Ihnen erhoben haben;
      </li>
      <li className="adsimple-311886100">
        ob Profiling durchgeführt wird, ob also Daten automatisch ausgewertet
        werden, um zu einem persönlichen Profil von Ihnen zu gelangen.
      </li>
    </ul>
  </li>
  <li className="adsimple-311886100">
    Sie haben laut Artikel 16 DSGVO ein Recht auf Berichtigung der Daten, was
    bedeutet, dass wir Daten richtig stellen müssen, falls Sie Fehler finden.
  </li>
  <li className="adsimple-311886100">
    Sie haben laut Artikel 17 DSGVO das Recht auf Löschung („Recht auf
    Vergessenwerden“), was konkret bedeutet, dass Sie die Löschung Ihrer Daten
    verlangen dürfen.
  </li>
  <li className="adsimple-311886100">
    Sie haben laut Artikel 18 DSGVO das Recht auf Einschränkung der
    Verarbeitung, was bedeutet, dass wir die Daten nur mehr speichern dürfen
    aber nicht weiter verwenden.
  </li>
  <li className="adsimple-311886100">
    Sie haben laut Artikel 19 DSGVO das Recht auf Datenübertragbarkeit, was
    bedeutet, dass wir Ihnen auf Anfrage Ihre Daten in einem gängigen Format zur
    Verfügung stellen.
  </li>
  <li className="adsimple-311886100">
    Sie haben laut Artikel 21 DSGVO ein Widerspruchsrecht, welches nach
    Durchsetzung eine Änderung der Verarbeitung mit sich bringt.
    <ul className="adsimple-311886100">
      <li className="adsimple-311886100">
        Wenn die Verarbeitung Ihrer Daten auf Artikel 6 Abs. 1 lit. e
        (öffentliches Interesse, Ausübung öffentlicher Gewalt) oder Artikel 6
        Abs. 1 lit. f (berechtigtes Interesse) basiert, können Sie gegen die
        Verarbeitung Widerspruch einlegen. Wir prüfen danach so rasch wie
        möglich, ob wir diesem Widerspruch rechtlich nachkommen können.
      </li>
      <li className="adsimple-311886100">
        Werden Daten verwendet, um Direktwerbung zu betreiben, können Sie
        jederzeit gegen diese Art der Datenverarbeitung widersprechen. Wir
        dürfen Ihre Daten danach nicht mehr für Direktmarketing verwenden.
      </li>
      <li className="adsimple-311886100">
        Werden Daten verwendet, um Profiling zu betreiben, können Sie jederzeit
        gegen diese Art der Datenverarbeitung widersprechen. Wir dürfen Ihre
        Daten danach nicht mehr für Profiling verwenden.
      </li>
    </ul>
  </li>
  <li className="adsimple-311886100">
    Sie haben laut Artikel 22 DSGVO unter Umständen das Recht, nicht einer
    ausschließlich auf einer automatisierten Verarbeitung (zum Beispiel
    Profiling) beruhenden Entscheidung unterworfen zu werden.
  </li>
</ul>
<p>
  <strong className="adsimple-311886100">Kurz gesagt:</strong> Sie haben Rechte
  &#8211; zögern Sie nicht, die oben gelistete verantwortliche Stelle bei uns zu
  kontaktieren!
</p>
<p>
  Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht
  verstößt oder Ihre datenschutzrechtlichen Ansprüche in sonst einer Weise
  verletzt worden sind, können Sie sich bei der Aufsichtsbehörde beschweren.
  In Deutschland gibt es für jedes Bundesland einen
  Datenschutzbeauftragten. Für nähere Informationen können Sie sich an die
  <a
    className="adsimple-311886100"
    href="https://www.bfdi.bund.de"
    target="_blank"
    rel="noopener noreferrer"
    > Bundesbeauftragte für den Datenschutz und die Informationsfreiheit
    (BfDI) </a
  >
  wenden. Für unser Unternehmen ist die folgende lokale Datenschutzbehörde
  zuständig:
</p>
<h2 id="nordrhein-westfalen-datenschutzbehoerde" className="adsimple-311886100">
  Nordrhein-Westfalen Datenschutzbehörde
</h2>
<p>
  <strong className="adsimple-311886100">Landesbeauftragte für Datenschutz: </strong>
  Bettina Gayk<br />
  <strong className="adsimple-311886100">Adresse: </strong>Kavalleriestraße 2-4,
  40213 Düsseldorf<br />
  <strong className="adsimple-311886100">Telefonnr.:</strong> 02 11/384 24-0<br />
  <strong className="adsimple-311886100">E-Mail-Adresse: </strong>
  poststelle@ldi.nrw.de<br />
  <strong className="adsimple-311886100">Website: </strong>
  <a
    className="adsimple-311886100"
    href="https://www.ldi.nrw.de/?tid=311886100"
    target="_blank"
    rel="noopener noreferrer"
    > https://www.ldi.nrw.de/</a
  >
</p>
<h2 id="webhosting" className="adsimple-311886100">Webhosting durch GitHub Pages</h2>
<table border="1" cellpadding="15">
  <tbody>
    <tr>
      <td>
        <strong className="adsimple-311886100">Webhosting Zusammenfassung</strong>
        <br />
        &#x1f465; Betroffene: Besucher der Website<br />
        &#x1f91d; Zweck: professionelles Hosting der Website und Absicherung des
        Betriebs<br />
        &#x1f4d3; Verarbeitete Daten: IP-Adresse, Zeitpunkt des Websitebesuchs,
        verwendeter Browser und weitere Daten. Die Website wird auf GitHub Pages gehostet. Die Datenschutzbestimmungen finden Sie unter
        <a href="https://help.github.com/articles/github-privacy-statement"> https://help.github.com/articles/github-privacy-statement</a>
        <br />
        &#x2696;&#xfe0f; Rechtsgrundlagen: Art. 6 Abs. 1 lit.f DSGVO
        (Berechtigte Interessen)
      </td>
    </tr>
  </tbody>
</table>
<h3 className="adsimple-311886100">Rechtsgrundlage</h3>
<p>
  Die Rechtmäßigkeit der Verarbeitung personenbezogener Daten im Rahmen des
  Webhosting ergibt sich aus Art. 6 Abs. 1 lit. f DSGVO (Wahrung der
  berechtigten Interessen), denn die Nutzung von professionellem Hosting bei
  einem Provider ist notwendig, um das Unternehmen im Internet sicher und
  nutzerfreundlich präsentieren und Angriffe und Forderungen hieraus
  gegebenenfalls verfolgen zu können.
</p>
<p>
  Zwischen uns und dem Hostingprovider besteht in der Regel ein Vertrag über die
  Auftragsverarbeitung gemäß Art. 28 f. DSGVO, der die Einhaltung von
  Datenschutz gewährleistet und Datensicherheit garantiert.
</p>
<h2 id="font-awesome-datenschutzerklaerung" className="adsimple-311886100">
  Font Awesome Datenschutzerklärung
</h2>
<table border="1" cellpadding="15">
  <tbody>
    <tr>
      <td>
        <strong className="adsimple-311886100"
          >Font Awesome Datenschutzerklärung Zusammenfassung</strong
        >
        <br />
        &#x1f465; Betroffene: Besucher der Website<br />
        &#x1f91d; Zweck: Optimierung unserer Serviceleistung<br />
        &#x1f4d3; Verarbeitete Daten: etwa IP-Adresse und und welche
        Icon-Dateien geladen werden<br />
        Mehr Details dazu finden Sie weiter unten in dieser
        Datenschutzerklärung.<br />
        &#x1f4c5; Speicherdauer: Dateien in identifizierbarer Form werden wenige
        Wochen gespeichert<br />
        &#x2696;&#xfe0f; Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO
        (Einwilligung), Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
      </td>
    </tr>
  </tbody>
</table>
<h3 className="adsimple-311886100">Was ist Font Awesome?</h3>
<p>
  Wir verwenden auf unserer Website Font Awesome des amerikanischen Unternehmens
  Fonticons (307 S. Main St., Suite 202, Bentonville, AR 72712, USA). Wenn Sie
  eine unserer Webseite aufrufen, wird die Web-Schriftart Font Awesome (im
  Speziellen Icons) über das Font Awesome Content Delivery Netzwerk (CDN)
  geladen. So werden die Texte bzw. Schriften und Icons auf jedem Endgerät
  passend angezeigt. In dieser Datenschutzerklärung gehen wir näher auf die
  Datenspeicherung und Datenverarbeitung durch diesen Service ein.
</p>
<p>
  Icons spielen für Websites eine immer wichtigere Rolle. Font Awesome ist eine
  Web-Schriftart, die speziell für Webdesigner und Webentwickler entwickelt
  wurde. Mit Font Awesome können etwa Icons mit Hilfe der Stylesheet-Sprache CSS
  nach Belieben skaliert und gefärbt werden. Sie ersetzen so alte Bild-Icons.
  Font Awesome CDN ist der einfachste Weg die Icons oder Schriftarten auf Ihre
  Website zu laden. Dafür mussten wir nur eine kleine Code-Zeile in unsere
  Website einbinden.
</p>
<h3 className="adsimple-311886100">
  Warum verwenden wir Font Awesome auf unserer Website?
</h3>
<p>
  Durch Font Awesome können Inhalte auf unserer Website besser aufbereitet
  werden. So können Sie sich auf unserer Website besser orientieren und die
  Inhalte leichter erfassen. Mit den Icons kann man sogar manchmal ganze Wörter
  ersetzen und Platz sparen. Da ist besonders praktisch, wenn wir Inhalte
  speziell für Smartphones optimieren.  Diese Icons werden statt als Bild als
  HMTL-Code eingefügt. Dadurch können wir die Icons mit CSS genauso bearbeiten,
  wie wir wollen. Gleichzeitig verbessern wir mit Font Awesome auch unsere
  Ladegeschwindigkeit, weil es sich nur um HTML-Elemente handelt und nicht um
  Icon-Bilder. All diese Vorteile helfen uns, die Website für Sie noch
  übersichtlicher, frischer und schneller zu machen.
</p>
<h3 className="adsimple-311886100">
  Welche Daten werden von Font Awesome gespeichert?
</h3>
<p>
  Zum Laden von Icons und Symbolen wird das Font Awesome Content Delivery
  Network (CDN) verwendet. CDNs sind Netzwerke von Servern, die weltweit
  verteilt sind und es möglich machen, schnell Dateien aus der Nähe zu laden. So
  werden auch, sobald Sie eine unserer Seiten aufrufen, die entsprechenden Icons
  von Font Awesome bereitgestellt.
</p>
<p>
  Damit die Web-Schriftarten geladen werden können, muss Ihr Browser eine
  Verbindung zu den Servern des Unternehmens Fonticons, Inc. herstellen. Dabei
  wird Ihre IP-Adresse erkannt. Font Awesome sammelt auch Daten darüber, welche
  Icon-Dateien wann heruntergeladen werden. Weiters werden auch technische Daten
  wie etwa Ihre Browser-Version, Bildschirmauflösung oder der Zeitpunkt der
  ausgerufenen Seite übertragen.
</p>
<p>Aus folgenden Gründen werden diese Daten gesammelt und gespeichert:</p>
<ul className="adsimple-311886100">
  <li className="adsimple-311886100">
    um Content Delivery Netzwerke zu optimieren
  </li>
  <li className="adsimple-311886100">
    um technische Fehler zu erkennen und zu beheben
  </li>
  <li className="adsimple-311886100">
    um CDNs vor Missbrauch und Angriffen zu schützen
  </li>
  <li className="adsimple-311886100">
    um Gebühren von Font Awesome Pro-Kunden berechnen zu können
  </li>
  <li className="adsimple-311886100">um die Beliebtheit von Icons zu erfahren</li>
  <li className="adsimple-311886100">
    um zu wissen, welchen Computer und welche Software Sie verwenden
  </li>
</ul>
<p>
  Falls Ihr Browser Web-Schriftarten nicht zulässt, wird automatisch eine
  Standardschrift Ihres PCs verwendet. Nach derzeitigem Stand unserer Erkenntnis
  werden keine Cookies gesetzt. Wir sind mit der Datenschutzabteilung von Font
  Awesome in Kontakt und geben Ihnen Bescheid, sobald wir näheres in Erfahrung
  bringen.
</p>
<h3 className="adsimple-311886100">
  Wie lange und wo werden die Daten gespeichert?
</h3>
<p>
  Font Awesome speichert Daten über die Nutzung des Content Delivery Network auf
  Servern auch in den Vereinigten Staaten von Amerika. Die CDN-Server befinden
  sich allerdings weltweit und speichern Userdaten, wo Sie sich befinden. In
  identifizierbarer Form werden die Daten in der Regel nur wenige Wochen
  gespeichert. Aggregierte Statistiken über die Nutzung von den CDNs können auch
  länger gespeichert werden. Personenbezogene Daten sind hier nicht enthalten.
</p>
<h3 className="adsimple-311886100">
  Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
</h3>
<p>
  Font Awesome speichert nach aktuellem Stand unseres Wissens keine
  personenbezogenen Daten über die Content Delivery Netzwerke. Wenn Sie nicht
  wollen, dass Daten über die verwendeten Icons gespeichert werden, können Sie
  leider unsere Website nicht besuchen. Wenn Ihr Browser keine Web-Schriftarten
  erlaubt, werden auch keine Daten übertragen oder gespeichert. In diesem Fall
  wird einfach die Standard-Schrift Ihres Computers verwendet.
</p>
<h3 className="adsimple-311886100">Rechtsgrundlage</h3>
<p>
  Wenn Sie eingewilligt haben, dass Font Awesome eingesetzt werden darf, ist die
  Rechtsgrundlage der entsprechenden Datenverarbeitung diese Einwilligung. Diese
  Einwilligung stellt laut<strong className="adsimple-311886100">
    Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)</strong
  >
  die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie bei
  der Erfassung durch Font Awesome vorkommen kann, dar.
</p>
<p>
  Von unserer Seite besteht zudem ein berechtigtes Interesse, Font Awesome zu
  verwenden, um unser Online-Service zu optimieren. Die dafür entsprechende
  Rechtsgrundlage ist
  <strong className="adsimple-311886100"
    >Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)</strong
  >. Wir setzen Font Awesome gleichwohl nur ein, soweit Sie eine Einwilligung
  erteilt haben.
</p>
<p>
  Wir weisen darauf hin, dass nach Meinung des Europäischen Gerichtshofs derzeit
  kein angemessenes Schutzniveau für den Datentransfer in die USA besteht. Die
  Datenverarbeitung geschieht im Wesentlichen durch Font Awesome. Dies kann dazu
  führen, dass gegebenenfalls Daten nicht anonymisiert verarbeitet und
  gespeichert werden. Ferner können gegebenenfalls US-amerikanische staatliche
  Behörden Zugriff auf einzelne Daten nehmen. Es kann ferner vorkommen, dass
  diese Daten mit Daten aus möglichen anderen Diensten von Font Awesome, bei
  denen Sie ein Nutzerkonto haben, verknüpft werden.
</p>
<p>
  Wenn Sie mehr über Font Awesome und deren Umgang mit Daten erfahren wollen,
  empfehlen wir Ihnen die Datenschutzerklärung unter
  <a className="adsimple-311886100" href="https://fontawesome.com/privacy"
    > https://fontawesome.com/privacy</a
  >
  und die Hilfeseite unter
  <a
    className="adsimple-311886100"
    href="https://fontawesome.com/help?tid=311886100"
    > https://fontawesome.com/help</a
  >.
</p>
<h2 id="google-fonts-datenschutzerklaerung" className="adsimple-311886100">
  Google Fonts Datenschutzerklärung
</h2>
<table border="1" cellpadding="15">
  <tbody>
    <tr>
      <td>
        <strong className="adsimple-311886100"
          >Google Fonts Datenschutzerklärung Zusammenfassung</strong
        >
        <br />
        &#x1f465; Betroffene: Besucher der Website<br />
        &#x1f91d; Zweck: Optimierung unserer Serviceleistung<br />
        &#x1f4d3; Verarbeitete Daten: Daten wie etwa IP-Adresse und CSS- und
        Schrift-Anfragen<br />
        Mehr Details dazu finden Sie weiter unten in dieser
        Datenschutzerklärung.<br />
        &#x1f4c5; Speicherdauer: Font-Dateien werden bei Google ein Jahr
        gespeichert<br />
        &#x2696;&#xfe0f; Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO
        (Einwilligung), Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
      </td>
    </tr>
  </tbody>
</table>
<h3 className="adsimple-311886100">Was sind Google Fonts?</h3>
<p>
  Auf unserer Website verwenden wir Google Fonts. Das sind die
  &#8220;Google-Schriften&#8221; der Firma Google Inc. Für den europäischen Raum
  ist das Unternehmen Google Ireland Limited (Gordon House, Barrow Street Dublin
  4, Irland) für alle Google-Dienste verantwortlich.
</p>
<p>
  Für die Verwendung von Google-Schriftarten müssen Sie sich nicht anmelden bzw.
  ein Passwort hinterlegen. Weiters werden auch keine Cookies in Ihrem Browser
  gespeichert. Die Dateien (CSS, Schriftarten/Fonts) werden über die
  Google-Domains fonts.googleapis.com und fonts.gstatic.com angefordert. Laut
  Google sind die Anfragen nach CSS und Schriften vollkommen getrennt von allen
  anderen Google-Diensten. Wenn Sie ein Google-Konto haben, brauchen Sie keine
  Sorge haben, dass Ihre Google-Kontodaten, während der Verwendung von Google
  Fonts, an Google übermittelt werden. Google erfasst die Nutzung von CSS
  (Cascading Style Sheets) und der verwendeten Schriftarten und speichert diese
  Daten sicher. Wie die Datenspeicherung genau aussieht, werden wir uns noch im
  Detail ansehen.
</p>
<p>
  Google Fonts (früher Google Web Fonts) ist ein Verzeichnis mit über 800
  Schriftarten, die
  <a
    className="adsimple-311886100"
    href="https://de.wikipedia.org/wiki/Google_LLC?tid=311886100"
    > Google</a
  > Ihren Nutzern kostenlos zu Verfügung stellen.
</p>
<p>
  Viele dieser Schriftarten sind unter der SIL Open Font License veröffentlicht,
  während andere unter der Apache-Lizenz veröffentlicht wurden. Beides
  sind freie Software-Lizenzen.
</p>
<h3 className="adsimple-311886100">
  Warum verwenden wir Google Fonts auf unserer Website?
</h3>
<p>
  Mit Google Fonts können wir auf der eigenen Webseite Schriften nutzen, und
  müssen sie nicht auf unserem eigenen Server hochladen. Google Fonts ist ein
  wichtiger Baustein, um die Qualität unserer Webseite hoch zu halten. Alle
  Google-Schriften sind automatisch für das Web optimiert und dies spart
  Datenvolumen und ist speziell für die Verwendung bei mobilen Endgeräten ein
  großer Vorteil. Wenn Sie unsere Seite besuchen, sorgt die niedrige Dateigröße
  für eine schnelle Ladezeit. Des Weiteren sind Google Fonts sichere Web Fonts.
  Unterschiedliche Bildsynthese-Systeme (Rendering) in verschiedenen Browsern,
  Betriebssystemen und mobilen Endgeräten können zu Fehlern führen. Solche
  Fehler können teilweise Texte bzw. ganze Webseiten optisch verzerren. Dank des
  schnellen Content Delivery Network (CDN) gibt es mit Google Fonts keine
  plattformübergreifenden Probleme. Google Fonts unterstützt alle gängigen
  Browser (Google Chrome, Mozilla Firefox, Apple Safari, Opera) und funktioniert
  zuverlässig auf den meisten modernen mobilen Betriebssystemen, einschließlich
  Android 2.2+ und iOS 4.2+ (iPhone, iPad, iPod). Wir verwenden die Google Fonts
  also, damit wir unser gesamtes Online-Service so schön und einheitlich wie
  möglich darstellen können.
</p>
<h3 className="adsimple-311886100">Welche Daten werden von Google gespeichert?</h3>
<p>
  Wenn Sie unsere Webseite besuchen, werden die Schriften über einen
  Google-Server nachgeladen. Durch diesen externen Aufruf werden Daten an die
  Google-Server übermittelt. So erkennt Google auch, dass Sie bzw. Ihre
  IP-Adresse unsere Webseite besucht. Die Google Fonts API wurde entwickelt, um
  Verwendung, Speicherung und Erfassung von Endnutzerdaten auf das zu
  reduzieren, was für eine ordentliche Bereitstellung von Schriften nötig
  ist. API steht übrigens für „Application Programming Interface“ und dient
  unter anderem als Datenübermittler im Softwarebereich.
</p>
<p>
  Google Fonts speichert CSS- und Schrift-Anfragen sicher bei Google und ist
  somit geschützt. Durch die gesammelten Nutzungszahlen kann Google feststellen,
  wie gut die einzelnen Schriften ankommen. Die Ergebnisse veröffentlicht Google
  auf internen Analyseseiten, wie beispielsweise Google Analytics. Zudem
  verwendet Google auch Daten des eigenen Web-Crawlers, um festzustellen, welche
  Webseiten Google-Schriften verwenden. Diese Daten werden in der
  BigQuery-Datenbank von Google Fonts veröffentlicht. Unternehmer und Entwickler
  nützen das Google-Webservice BigQuery, um große Datenmengen untersuchen und
  bewegen zu können.
</p>
<p>
  Zu bedenken gilt allerdings noch, dass durch jede Google Font Anfrage auch
  Informationen wie Spracheinstellungen, IP-Adresse, Version des Browsers,
  Bildschirmauflösung des Browsers und Name des Browsers automatisch an die
  Google-Server übertragen werden. Ob diese Daten auch gespeichert werden, ist
  nicht klar feststellbar bzw. wird von Google nicht eindeutig kommuniziert.
</p>
<h3 className="adsimple-311886100">
  Wie lange und wo werden die Daten gespeichert?
</h3>
<p>
  Anfragen für CSS-Assets speichert Google einen Tag lang auf seinen Servern,
  die hauptsächlich außerhalb der EU angesiedelt sind. Das ermöglicht uns,
  mithilfe eines Google-Stylesheets die Schriftarten zu nutzen. Ein Stylesheet
  ist eine Formatvorlage, über die man einfach und schnell z.B. das Design bzw.
  die Schriftart einer Webseite ändern kann.
</p>
<p>
  Die Font-Dateien werden bei Google ein Jahr gespeichert. Google verfolgt damit
  das Ziel, die Ladezeit von Webseiten grundsätzlich zu verbessern. Wenn
  Millionen von Webseiten auf die gleichen Schriften verweisen, werden sie nach
  dem ersten Besuch zwischengespeichert und erscheinen sofort auf allen anderen
  später besuchten Webseiten wieder. Manchmal aktualisiert Google
  Schriftdateien, um die Dateigröße zu reduzieren, die Abdeckung von Sprache zu
  erhöhen und das Design zu verbessern.
</p>
<h3 className="adsimple-311886100">
  Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
</h3>
<p>
  Jene Daten, die Google für einen Tag bzw. ein Jahr speichert können nicht
  einfach gelöscht werden. Die Daten werden beim Seitenaufruf automatisch an
  Google übermittelt. Um diese Daten vorzeitig löschen zu können, müssen Sie den
  Google-Support auf
  <a
    className="adsimple-311886100"
    href="https://support.google.com/?hl=de&amp;tid=311886100"
    > https://support.google.com/?hl=de&amp;tid=311886100</a
  >
  kontaktieren. Datenspeicherung verhindern Sie in diesem Fall nur, wenn Sie
  unsere Seite nicht besuchen.
</p>
<p>
  Anders als andere Web-Schriften erlaubt uns Google uneingeschränkten Zugriff
  auf alle Schriftarten. Wir können also unlimitiert auf ein Meer an
  Schriftarten zugreifen und so das Optimum für unsere Webseite rausholen. Mehr
  zu Google Fonts und weiteren Fragen finden Sie auf
  <a
    className="adsimple-311886100"
    href="https://developers.google.com/fonts/faq?tid=311886100"
    > https://developers.google.com/fonts/faq?tid=311886100</a
  >. Dort geht zwar Google auf datenschutzrelevante Angelegenheiten ein, doch
  wirklich detaillierte Informationen über Datenspeicherung sind nicht
  enthalten. Es ist relativ schwierig, von Google wirklich präzise Informationen
  über gespeicherten Daten zu bekommen.
</p>
<h3 className="adsimple-311886100">Rechtsgrundlage</h3>
<p>
  Wenn Sie eingewilligt haben, dass Google Fonts eingesetzt werden darf, ist die
  Rechtsgrundlage der entsprechenden Datenverarbeitung diese Einwilligung. Diese
  Einwilligung stellt laut <strong className="adsimple-311886100">
    Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)</strong
  >
  die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie bei
  der Erfassung durch Google Fonts vorkommen kann, dar.
</p>
<p>
  Von unserer Seite besteht zudem ein berechtigtes Interesse, Google Font zu
  verwenden, um unser Online-Service zu optimieren. Die dafür entsprechende
  Rechtsgrundlage ist
  <strong className="adsimple-311886100"
    > Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)</strong
  >. Wir setzen Google Font gleichwohl nur ein, soweit Sie eine Einwilligung
  erteilt haben.
</p>
<p>
  Google verarbeitet Daten von Ihnen u.a. auch in den USA. Wir weisen darauf
  hin, dass nach Meinung des Europäischen Gerichtshofs derzeit kein angemessenes
  Schutzniveau für den Datentransfer in die USA besteht. Dies kann mit
  verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der
  Datenverarbeitung einhergehen.
</p>
<p>
  Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
  (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
  insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet Google
  sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO).
  Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind von der
  EU-Kommission bereitgestellte Mustervorlagen und sollen sicherstellen, dass
  Ihre Daten auch dann den europäischen Datenschutzstandards entsprechen, wenn
  diese in Drittländer (wie beispielsweise in die USA) überliefert und dort
  gespeichert werden. Durch diese Klauseln verpflichtet sich Google, bei der
  Verarbeitung Ihrer relevanten Daten, das europäische Datenschutzniveau
  einzuhalten, selbst wenn die Daten in den USA gespeichert, verarbeitet und
  verwaltet werden. Diese Klauseln basieren auf einem Durchführungsbeschluss der
  EU-Kommission. Sie finden den Beschluss und die entsprechenden
  Standardvertragsklauseln u.a. hier:
  <a
    className="adsimple-311886100"
    href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
    target="_blank"
    rel="noopener noreferrer"
    > https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de</a
  >
</p>
<p>
  Die Google Ads Datenverarbeitungsbedingungen (Google Ads Data Processing
  Terms), welche auch den Standardvertragsklauseln für Google Fonts entsprechen,
  finden Sie unter
  <a
    className="adsimple-311886100"
    href="https://business.safety.google/adsprocessorterms/"
    target="_blank"
    rel="noopener noreferrer"
    > https://business.safety.google/adsprocessorterms/</a
  >.
</p>
<p>
  Welche Daten grundsätzlich von Google erfasst werden und wofür diese Daten
  verwendet werden, können Sie auch auf
  <a
    className="adsimple-311886100"
    href="https://policies.google.com/privacy?hl=de&amp;tid=311886100"
    > https://www.google.com/intl/de/policies/privacy/</a
  >
  nachlesen.
</p>
<h3 className="adsimple-311886100">Was ist emailjs?</h3>
<p>
    Über die Schnittstelle emailjs werden Kontaktanfragen übermittelt, wobei die Kontaktdaten auf keinem Server gespeichert,
    sondern sofort weitergeleitet werden
</p>
<p>Alle Texte sind urheberrechtlich geschützt.</p>
<p style={{marginTop: "15px"}}>
  Quelle: Erstellt mit dem
  <a
    href="https://www.adsimple.de/datenschutz-generator/"
    title="Datenschutz Generator von AdSimple für Deutschland"
    > Datenschutz Generator </a
  >
  von AdSimple
</p>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};
